module.exports = __webpack_public_path__ + "static/media/shufat_logo.f3dd0c59.jpg";